export var getShippingSettings = function (siteStore) {
    return {
        shippingDisclaimer: siteStore.priceSettings.shippingDisclaimer,
    };
};
//# sourceMappingURL=getShippingSettings.js.map